module.exports = __webpack_public_path__ + "static/img/timg.afe40440.jpg";